import { createRouteRef } from '@backstage/frontend-plugin-api';

/**
 * Route ref for the Scorecards page (the Tech Insights `page:tech-insights`
 * extension, overridden by this plugin's module). Exported so other plugins
 * (e.g. the home plugin's "My Teams' Scorecards" widget) can link to it
 * without hardcoding a URL.
 */
export const scorecardsRouteRef = createRouteRef();
